var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0200195,
    width: 63.99,
    height: 63.99,
    rx: 31.995,
    fill: "#16A34A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6567 21.3433H21.3234C19.8506 21.3433 18.6567 22.5372 18.6567 24.0099V40.0099C18.6567 41.4827 19.8506 42.6766 21.3234 42.6766H42.6567C44.1295 42.6766 45.3234 41.4827 45.3234 40.0099V24.0099C45.3234 22.5372 44.1295 21.3433 42.6567 21.3433Z",
    stroke: "#16A34A",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3234 25.3433L33.3634 32.9433C32.9518 33.2012 32.4758 33.3379 31.9901 33.3379C31.5043 33.3379 31.0284 33.2012 30.6167 32.9433L18.6567 25.3433",
    stroke: "#16A34A",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.be4aa5d9d84b4574ed3bc97ffe7bd3b2.svg";
export { ForwardRef as ReactComponent };